"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cagnano-varano": {
    "201acef7": [{
      "hkey": "87bbae2a",
      "slug": "capoiale-isola-varano",
      "name": "Capoiale-Isola Varano",
      "primary": true,
      "skipSearch": false
    }],
    "capoiale": [{
      "hkey": "87bbae2a",
      "slug": "capoiale-isola-varano",
      "name": "Capoiale-Isola Varano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "95aa5fce": [{
      "hkey": "49f5da16",
      "slug": "cagnano-varano",
      "name": "Cagnano Varano",
      "primary": true,
      "skipSearch": false
    }],
    "san-nicola-imbuti": [{
      "hkey": "49f5da16",
      "slug": "cagnano-varano",
      "name": "Cagnano Varano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;